const basicCustomerChargeRate = {
  name: 'Basic Customer Charge',
  rateElementType: 'FixedPerMonth',
  rateComponents: [
    {
      charge: 17.33,
      name: 'Basic Customer Charge',
    },
  ],
};

const energyCharge = {
  name: 'Energy Charge',
  rateElementType: 'EnergyTimeOfUse',
  rateComponents: [
    {
      charge: 0.07576, // 7.576¢ per kWh
      months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // All Months
      name: 'Energy Charge (All Months)',
    },
  ],
};

const electricSupplyCharge = {
  name: 'Electric Supply Charge per kWh',
  rateElementType: 'EnergyTimeOfUse',
  rateComponents: [
    {
      charge: 0.0006018, //  0.060180¢ per kWh
      months: [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11], // All Months
      name: 'Energy Charge (All Months)',
    },
  ],
};

const residentialRate = () => {
  return {
    name: 'Residential Service',
    title: 'National Grid SC1',
    rateElements: [basicCustomerChargeRate, energyCharge, electricSupplyCharge],
  };
};

export default residentialRate;
